// import Topbar from '@component/topbar/Topbar';
import { Box, Grid } from '@material-ui/core';
import React from 'react';

// PlainLayout.propTypes = {
//   children: PropTypes.node
// };

export default function PlainLayout({ children }) {
  return (
    <>
      {/* <Topbar /> */}
      <Box sx={{ my: '2rem' }}>
        <Grid container spacing={3}>
          <Grid item lg={3} xs={12} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
          <Grid item lg={9} xs={12}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
